import { fetchHandler } from "../Handler/Handler";

export const GETEnquires = async (slugname) => {
    try {

        const response = await fetchHandler({
            method: "GET",
            endpoint: `/vendor/${slugname}/enquiries`,
            data: null,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
export const updateEnquiryStatus = async (slugname,id,data) => {
    try {

        const response = await fetchHandler({
            method: "PUT",
            // /vendor/{{subdomine}}/enquiries/:enquiryId
            endpoint: `/vendor/${slugname}/enquiries/${id}`,
            data: data,
        });
        return response;
    } catch (error) {
        console.error("Unexpected error:", error);
    }
};
